module.exports = __webpack_public_path__ + "media/images/icons/price-blue-68fae3ed49c3506cff8d2ebbbba8fbb2.svg";